
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/homemade-food-delivery/metros-we-serve",
      function () {
        return require("private-next-pages/homemade-food-delivery/metros-we-serve.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/homemade-food-delivery/metros-we-serve"])
      });
    }
  